// React
import { useEffect, useRef } from 'react';

// Animation
import { animate, easeInOut, inView } from 'framer-motion';

// Utils
import cn from '@/utils/cn';

// Styles
import styles from '../Animations.module.css';

const config = {
  type: 'spring' as const,
  duration: 1,
  ease: easeInOut,
};

interface RevealVerticalScaleInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  /**
   * Seuil d’intersection pour déclencher l’animation (API Framer `inView`).
   * Par défaut `"some"` : dès qu’une partie du bloc est visible.
   * Éviter un nombre type 0,5 sur des sections hautes (hero) : sur mobile le viewport
   * couvre souvent moins de 50 % de la hauteur du bloc, l’animation ne partait jamais.
   */
  amount?: number | 'some' | 'all';
}

function RevealVerticalScaleIn({ children, className = '', delay = 0, amount = 'some' }: RevealVerticalScaleInProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      inView(
        ref.current,
        (element) => {
          animate(
            element,
            {
              opacity: 1,
              transform: ['scaleY(0)', 'scaleY(1)'],
            },
            {
              ...config,
              bounce: 0.2,
              stiffness: 50,
              delay: delay + 0.3,
            },
          );
        },
        {
          amount,
        },
      );
    }
  }, [delay, amount]);

  return (
    <div className={cn([styles.scalein, className])} ref={ref}>
      {children}
    </div>
  );
}

export default RevealVerticalScaleIn;
